// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=IBM+Plex+Sans:wght@400;450;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'IBM Plex Sans', sans-serif;
  text-align: left;
  color: #111827;
  background: #fff;
}

h1, h2, h3, h4, .font-heading {
  font-family: 'Manrope', sans-serif;
  letter-spacing: -0.02em;
}

::selection {
  background: #2563EB;
  color: #fff;
}

.scroll-thin::-webkit-scrollbar { width: 6px; height: 6px; }
.scroll-thin::-webkit-scrollbar-thumb { background: #D1D5DB; border-radius: 3px; }
.scroll-thin::-webkit-scrollbar-track { background: transparent; }

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}
.fade-up { animation: fadeUp 0.25s ease-out both; }

@keyframes pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
.mic-active { animation: pulse-dot 1s infinite; color: #EF4444 !important; }

.email-html img { max-width: 100%; height: auto; }
.email-html table { max-width: 100%; }
.email-html a { color: #2563eb; }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,kCAAkC,UAAU,EAAE,WAAW,EAAE;AAC3D,wCAAwC,mBAAmB,EAAE,kBAAkB,EAAE;AACjF,wCAAwC,uBAAuB,EAAE;;AAEjE;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA,WAAW,qCAAqC,EAAE;;AAElD;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;AACA,cAAc,gCAAgC,EAAE,yBAAyB,EAAE;;AAE3E,kBAAkB,eAAe,EAAE,YAAY,EAAE;AACjD,oBAAoB,eAAe,EAAE;AACrC,gBAAgB,cAAc,EAAE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=IBM+Plex+Sans:wght@400;450;500;600&display=swap');\n\nbody {\n  font-family: 'IBM Plex Sans', sans-serif;\n  text-align: left;\n  color: #111827;\n  background: #fff;\n}\n\nh1, h2, h3, h4, .font-heading {\n  font-family: 'Manrope', sans-serif;\n  letter-spacing: -0.02em;\n}\n\n::selection {\n  background: #2563EB;\n  color: #fff;\n}\n\n.scroll-thin::-webkit-scrollbar { width: 6px; height: 6px; }\n.scroll-thin::-webkit-scrollbar-thumb { background: #D1D5DB; border-radius: 3px; }\n.scroll-thin::-webkit-scrollbar-track { background: transparent; }\n\n@keyframes fadeUp {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n.fade-up { animation: fadeUp 0.25s ease-out both; }\n\n@keyframes pulse-dot {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n.mic-active { animation: pulse-dot 1s infinite; color: #EF4444 !important; }\n\n.email-html img { max-width: 100%; height: auto; }\n.email-html table { max-width: 100%; }\n.email-html a { color: #2563eb; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
